import type { IconProps } from '.';

/**
 * Chevron Bottom Icon SVG component.
 *
 * IMPORTANT:
 * Importing a SVG directly tells the compiler to use Webpack, thus including the whole file in the bundle.
 * By using a component instead, we can leverage server components and return HTML directly from the server.
 */

const ChevronBottomIcon = ({ className }: IconProps) => (
  <svg
    role="presentation"
    aria-hidden="true"
    focusable="false"
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    className={className}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12 14.2929L6.35359 8.64642L5.64648 9.35353L12 15.7071L18.3536 9.35353L17.6465 8.64642L12 14.2929Z"
      fill="white"
    />
  </svg>
);

export default ChevronBottomIcon;
